<template>
  <header class="flex justify-center header public">
    <head-title></head-title>
  </header>
</template>

<script>
import HeadTitle from './HeadTitle.vue'

export default {
  name: 'PublicHeadBar',
  components: { HeadTitle },

  data () {
    return {}
  }
}
</script>
